'use strict';

var BuildingTours = new Class({
	Implements: [Events, Options],

	options: {
		cls: 'w_building_tours',
		selector_position: 'top' //can be 'top' or 'overlap'
	},

	initialize: function initialize(element, options) {
		this._element = element || document.getElement('.' + this.options.cls);

		if (!this._element) return;

		this.build();
	},

	build: function build() {
		var self = this;

		Core.add_froogaloop();

		this._imagestrip = this._element.getElement('.w_imagestrip');
		this._bld_content = this._element.getElement('.bld_content');

		if (this._imagestrip) {
			this._istrip_container = this._imagestrip.getElement('.w_imagestrip_scroller');
			this._bld_content.addClass('loading');
		}

		var _select = this._element.getElement('.w_styled_select select');

		if (_select) {
			var _select_options = _select.getElements('option');

			_select.addEvent('change', function (_el) {
				$(document.body).setStyle('cursor', 'wait');

				self.inject_imagestrip(_el);
			});

			this._element.getElements('.w_styled_select .option').each(function (_option, i) {
				if (_option.hasClass('selected')) {
					_select.fireEvent('change', _select_options[i]);
				}
			});
		}

		this._element.getElements('.bld_info [data-url]').each(function (_el) {
			var url = _el.getAttribute('data-url');

			if (url != '') {
				_el.addEvent('click', function () {
					window.location = url;
				});
			}
		});

		this.add_selector_toggle();
	},

	inject_imagestrip: function inject_imagestrip(_el) {
		if (!_el || !this._istrip_container) return;

		var rpc = _el.getAttribute('data-rpc');

		if (!rpc || rpc == '') return;

		var self = this;

		new Remote({
			rpc: rpc,
			onSuccess: function onSuccess(data) {
				var _new_istrip = self._imagestrip.clone();

				_new_istrip.inject(self._imagestrip, 'after');
				self._imagestrip.dispose();
				self._imagestrip = _new_istrip;
				self._istrip_container = self._imagestrip.getElement('.w_imagestrip_scroller');
				self._istrip_container.set('html', this.get_data().content);

				new Imagestrip(self._imagestrip, {
					auto_move: false,
					amount: 5
				});

				self.process_imgs();
			}
		});
	},

	process_imgs: function process_imgs() {
		var self = this;
		var _imgs = this._imagestrip.getElements('.w_imagestrip_photo');

		_imgs.each(function (_el) {
			self.center_img(_el);

			_el.addEvents({
				'click': function click() {
					var _active_imgs = self._imagestrip.getElement('.w_imagestrip_photo.selected');

					if (_active_imgs) {
						_active_imgs.removeClass('selected');
					}

					_el.addClass('selected');

					var rpc = _el.getProperty('data-rpc');
					self._bld_content.set('html', '');
					self._bld_content.addClass('loading');

					new Remote({
						rpc: rpc,
						onSuccess: function onSuccess() {
							self._bld_content.set('html', this.get_data().content);
							self._bld_content.removeClass('loading');
							self.first_time_close = true;

							self.get_player();

							document.getElements('.bld_info [data-url]').each(function (_el) {
								var url = _el.getAttribute('data-url');

								if (url != '') {
									_el.addEvent('click', function () {
										window.location = url;
									});
								}
							});
						}
					});
				}
			});
		});

		_imgs[0].fireEvent('click');

		$(document.body).setStyle('cursor', 'default');
	},

	center_img: function center_img(_el) {
		var _img = _el.getElement('img');
		var src = _img.getProperty('src');

		new Asset.image(src, {
			onLoad: function onLoad() {
				var ml = (_el.getSize().x - _img.getSize().x) / 2;
				_img.setStyle('margin-left', ml);
			}
		});
	},

	add_selector_toggle: function add_selector_toggle() {
		var _selector = this._element.getElement('.' + this.options.cls + '_selector');
		var _toggle = this._element.getElement('.w_opener .toggle');

		if (!_selector || !_toggle) return;

		if (this.options.selector_position == 'overlap') {
			this.opener = new Opener(_toggle, _selector, {
				close_ability: true
			});

			_toggle.fireEvent('click');
		} else {
			this._element.addClass('_selector_no_hide');
		}
	},

	get_player: function get_player() {
		var _iframe = this._bld_content.getElement('iframe');

		if (!_iframe) return;

		this.player = Froogaloop(_iframe);
		this.player.addEvent('ready', this.handle_ready.bind(this));
	},

	handle_ready: function handle_ready() {
		this.player.addEvent('playProgress', this.handle_play.bind(this));
	},

	handle_play: function handle_play() {
		if (this.first_time_close && this.opener && this.opener.open) {
			this.opener.close_cnt();
			this.first_time_close = false;
		}
	}
});
'use strict';

/*
---
description: FED Process
authors:
- David Chan CK
- Anton Burov
license:
- MIT-style license
requires:
- core/1.3.2: '*'
- more/1.3.2.1: [Utilities.Assets]
provides: [LazyLoader]
...
*/

var Imagestrip = new Class({

	Implements: [Events, Options],

	options: {
		cls: 'w_imagestrip',
		scroll_speed: 700,
		btn_speed: 350,
		current_cls: '_current',
		amount: 1, //amount of elements to move at a time
		dynamic: false, //add height to scroller el. Change dynamically elems size
		show_next_on_preview: false, //Make sense only if dynamic = true
		preview_width: 0, //Make sense only if dynamic = true
		display_items: 1, //Make sense only if dynamic = true
		show_last_item_on_edge: false, //Make sense only if dynamic = true
		stick_arrows: false, //always show arrows.
		responsive: false //change arrows style while window resizing

	},

	initialize: function initialize(element, options) {
		this.setOptions(options);
		this._element = document.id(element);

		if (this._element) {
			this.build();
		}
	},

	build: function build() {
		var opts = this.options,
		    fcls = '.' + opts.cls,
		    cclass = '.' + opts.current_cls,
		    _curel = this._element.getElement(cclass);

		this._photos = this._element.getElements(fcls + '_photo');
		this._scroller = this._element.getElement(fcls + '_scroller');
		this.cont_width = 0;
		this._has_current = false;

		if (_curel && _curel != this._photos[0]) {
			this._has_current = true;
			this.first = _curel.getProperty('data-idx').toInt();
		} else {
			this.first = 0;
		}

		if (this._photos.length > 0) {
			this._move_left = this._element.getElement(fcls + '_arrow_previous');
			this._move_right = this._element.getElement(fcls + '_arrow_next');

			this._cont = this._element.getElement(fcls + '_images_container');
			this.main_w = this._element.getSize().x;

			this._photos[this._photos.length - 1].addClass('_no_margin');

			this.photo_margin = 0;

			if (this._photos[0]) {
				this.photo_margin = this._photos[0].getStyle('margin-right').toInt();
			}

			this._photos.each(function (photo) {
				this.cont_width += photo.getSize().x + this.photo_margin;
			}.bind(this));

			this.cont_width -= this.photo_margin;

			this._cont.setStyle('width', this.cont_width);

			if (opts.dynamic) {
				this.set_dynamic_size();
			}

			if (this.options.responsive) {
				this.add_movement();

				var self = this;

				window.addEvent('resize', function (e) {
					if (self.cont_width < self._element.getSize().x) {
						self._move_left.hide();
						self._move_right.hide();
					} else {
						self._move_left.show();
						self._move_right.show();
					}
				});
				window.fireEvent('resize');
			} else {
				if (this.cont_width > this.main_w) {
					this.add_movement();
				} else {
					this._move_left.hide();
					this._move_right.hide();
				}
			}
		} else {
			this._element.hide();
		}
	},

	add_movement: function add_movement() {
		var _click_event = Browser.platform == 'ios' ? 'touchstart' : 'click';

		if (!this.options.stick_arrows) this._move_left.hide();else this._move_left.addClass('_inactive');

		this._move_left.removeEvents().addEvent(_click_event, function () {
			this.previous();
			clearInterval(this.timer);
		}.bind(this));

		this._move_right.removeEvents().addEvent(_click_event, function () {
			this.next();
			clearInterval(this.timer);
		}.bind(this));

		if (Browser.platform != 'ios' && !this.options.stick_arrows) {
			this._element.addEvents({
				'mouseenter': function () {
					this.show_arrows();
				}.bind(this),
				'mouseleave': function () {
					this.hide_arrows();
				}.bind(this)
			});
		}

		if (Browser.platform == 'ios') {
			(function () {
				this.show_arrows();
			}).bind(this).delay(200);
		}

		this.is_running = false;

		this.animate = new Fx.Scroll(this._scroller, { link: 'ignore',
			duration: this.options.scroll_speed,
			transition: Fx.Transitions.Quad.easeOut,
			onComplete: function () {
				this.is_running = false;
			}.bind(this)
		});

		this.animate.set(0, 0);

		this.animate_l_a = new Fx.Morph(this._move_left, { link: 'cancel',
			duration: this.options.btn_speed,
			transition: Fx.Transitions.Quad.easeOut
		});

		this.animate_r_a = new Fx.Morph(this._move_right, { link: 'cancel',
			duration: this.options.btn_speed,
			transition: Fx.Transitions.Quad.easeOut
		});

		if (this._has_current) {
			this.animate.toElement(this._photos[this.first]);
			this._move_left.show();
		}

		if (this.options.auto_move == true) this.timer = this.next.periodical(3000, this);

		if (Browser.platform != 'ios' && !this.options.stick_arrows) {
			(function () {
				this.hide_arrows();
			}).bind(this).delay(500);
		}

		this._move_right.show();
	},

	next: function next() {

		if (this._move_right.hasClass('_inactive')) return;

		if (this.is_running == false) {
			if (!this.options.stick_arrows) this._move_left.setStyle('display', 'block');else this._move_left.removeClass('_inactive');

			this.is_running = true;
			this.first += this.options.amount;

			var rest_width = 0;

			for (var i = this.first; i < this._photos.length; i++) {

				rest_width += this._photos[i].getSize().x + this.photo_margin;
			}

			rest_width -= this.photo_margin;

			if (rest_width <= this._scroller.getSize().x) {
				this.animate.toRight();

				if (!this.options.stick_arrows) this._move_right.setStyle('display', 'none');else this._move_right.addClass('_inactive');

				this.first -= this.options.amount;
				this.first++;
			} else {
				this.animate.toElement(this._photos[this.first]);
			}
		}
	},

	previous: function previous() {
		if (this._move_left.hasClass('_inactive')) return;

		if (this.is_running == false) {
			this.is_running = true;

			if (this.first > this.options.amount) this.first -= this.options.amount;else this.first = 0;

			if (!this.options.stick_arrows) this._move_right.setStyle('display', 'block');else this._move_right.removeClass('_inactive');

			if (this.first == 0) {
				if (!this.options.stick_arrows) this._move_left.setStyle('display', 'none');else this._move_left.addClass('_inactive');
			}

			this.animate.toElement(this._photos[this.first]);
		}
	},

	show_arrows: function show_arrows() {
		if (this.options.stick_arrows) return;

		this.animate_l_a.start({ 'opacity': 1 });
		this.animate_r_a.start({ 'opacity': 1 });
	},

	hide_arrows: function hide_arrows() {
		if (this.options.stick_arrows) return;
		this.animate_l_a.start({ 'opacity': 0 });
		this.animate_r_a.start({ 'opacity': 0 });
	},

	set_dynamic_size: function set_dynamic_size() {
		var self = this;
		var percentage_width = 100 / this.options.display_items;
		var new_photo_width = this._cont.getStyle('min-width').toInt() * (percentage_width / 100);
		var total_margin = this.photo_margin * (this._photos.length - 1);

		if (this.options.show_next_on_preview) {
			new_photo_width -= this.options.preview_width;
		}

		this.cont_width = new_photo_width.toFixed() * this._photos.length;
		this.cont_width += total_margin;
		this.original_cont_width = this.cont_width;

		// this._cont.setStyle('width', this.cont_width);

		// this._photos.each(function(photo){
		// 	photo.setStyle('width', new_photo_width);
		// });

		this.get_height_on_image_load();

		window.addEvent('resize', function (e) {
			if (document.getSize().x < self._cont.getStyle('min-width').toInt()) {
				return;
			}

			new_photo_width = document.getSize().x * (percentage_width / 100);

			if (self.options.show_next_on_preview) {
				new_photo_width -= self.options.preview_width;
			}

			self.cont_width = new_photo_width.toFixed() * self._photos.length;
			self.cont_width += total_margin;

			if (self.options.show_last_item_on_edge) {
				self.cont_width += self.options.preview_width;
			}

			self._photos.each(function (photo) {
				photo.setStyle('width', new_photo_width);
			});

			self._cont.setStyle('width', self.cont_width);
			self._scroller.setStyle('height', self._photos[0].getSize().y);

			if (self.animate) {
				var x = new_photo_width * self.first + self.photo_margin * self.first;
				self.animate.set(x, 0);
			}
		});

		window.fireEvent('resize');
	},

	get_height_on_image_load: function get_height_on_image_load() {
		this._element.setStyle('opacity', 0);
		var _img = this._photos[0].getElement('img');

		if (!_img) return;

		var src = _img.clone().get('src');
		Asset.image(src, {
			onLoad: function () {
				this.data_height = _img.getSize().y;
				this._scroller.setStyle('height', this.data_height);
				window.fireEvent('resize');
				this._element.setStyle('opacity', 1);
			}.bind(this),
			onError: function () {
				window.fireEvent('resize');
				this._element.setStyle('opacity', 1);
			}.bind(this)
		});
	}
});

Imagestrip.extend({
	class_scroller: function class_scroller() {
		return 'w_imagestrip_scroller';
	},
	class_photo: function class_photo() {
		return 'w_imagestrip_photo';
	},
	class_image_legend: function class_image_legend() {
		return 'w_imagestrip_image_legend';
	},
	template_container: function template_container() {
		return new Element('div', {
			'class': 'w_imagestrip_images_container clearfix'
		});
	},
	template_photo: function template_photo() {
		var _e = new Element('div', {
			'class': 'w_imagestrip_photo'
		});
		return _e;
	},
	template_image: function template_image() {
		var _e = new Element('div', {
			'class': 'w_imagestrip_image'
		});
		return _e;
	},
	template_image_legend: function template_image_legend() {
		var _e = new Element('div', {
			'class': 'w_imagestrip_image_legend'
		});
		return _e;
	}
});
"use strict";

Page.Bvi = new Class({
	Extends: Page,

	build: function build() {
		this.parent();

		new BuildingTours();
	}
});
//# sourceMappingURL=bvi.js.map
